import axios from "axios";
import { authService } from "./auth.service";

const baseUrl = process.env.REACT_APP_BASE_URL_API;

export const pesquisaApi = {
  async setImg(img) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const headers = await axios.post(`${baseUrl}pesquisa/v1/img`, img, {
          headers: {
            'Authorization': `Token ${user.token}`,
            'Content-Type': 'multipart/form-data',
          }
        })
        console.log("headers", headers)
        return headers
      } catch (error) {
        console.log(error)
      }
    }
  },
  async markAsReview(headerId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.post(
          `${baseUrl}pesquisa/v1/headers/${headerId}/mark-as-review`,
          {},
          { headers: { 'Authorization': `Token ${user.token}` } }
        );
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.error || 'Erro ao marcar como revisão');
      }
    }
  },
  async approveHeader(headerId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.post(
          `${baseUrl}pesquisa/v1/headers/${headerId}/approve`,
          {},
          { headers: { 'Authorization': `Token ${user.token}` } }
        );
        return response.data;
      } catch (error) {
        throw new Error(error.response?.data?.error || 'Erro ao aprovar');
      }
    }
  },
  async getHeaders(page = 1, pageSize = 10, search = '', filters = {}) {
    let user = authService.getLoggedUser();
    if (user) {
      let userLoggedId = await authService.getLoggedUserId();

      if (!user.id) {
        await authService.Logout();
      }

      const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString(),
        ordering: '-id_header'
      });

      if (search) {
        params.append('search', search);
      }

      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
      });

      const url = `${baseUrl}pesquisa/v1/headers/${user.id}/user-headers/?${params.toString()}`;
      console.log(`🔍 Buscando headers: ${url}`);

      return axios.get(url, {
        headers: {
          Authorization: `Token ${user.token}`
        }
      });
    } else {
      return null;
    }
  },

  async getHeadersAnotherUser(anotherUserId, page = 1, pageSize = 10, search = '', filters = {}) {
    let user = authService.getLoggedUser();
    if (user) {
      const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString(),
        ordering: '-id_header'
      });

      if (search) {
        params.append('search', search);
      }

      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          params.append(key, value);
        }
      });

      const url = `${baseUrl}pesquisa/v1/headers/${anotherUserId}/user-headers/?${params.toString()}`;

      return axios.get(url, {
        headers: {
          Authorization: `Token ${user.token}`
        }
      });
    } else {
      return null;
    }
  },

  async getUsers() {
    let user = authService.getLoggedUser();
    if (user) {
      const res = await axios.get(`${baseUrl}users`);
      return res;
    } else {
      return null;
    }
  },

  async getSections(idHeader) {
    let user = authService.getLoggedUser();
    if (user) {
      return axios.get(`${baseUrl}pesquisa/v1/sections?search=${idHeader}`, {
        headers: {
          Authorization: `Token ${user.token}`,
        },
      });
    } else {
      return null;
    }
  },

  async setSections(formData) {
    let user = authService.getLoggedUser();
    if (user) {
      let res = await axios
        .post(`${baseUrl}pesquisa/v1/sections`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Token ${user.token}`,
          }
        })
      return res.data;
    } else {
      return null;
    }
  },

  async uploadSections(formData, id) {
    let user = authService.getLoggedUser();
    if (user) {
      let res = await axios
        .patch(`${baseUrl}pesquisa/v1/sections/${id}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Token ${user.token}`,
          },
        })
        .then(function (response) {
          console.log(response.data);
        })
        .catch(function (error) {
          console.log(error.response.data);
        });
    } else {
      return null;
    }
  },

  async setHeaders(data) {
    let user = authService.getLoggedUser();
    if (user) {
      let res = await axios.post(`${baseUrl}pesquisa/v1/headers`, data, {
        headers: {
          'Authorization': `Token ${user.token}`,
        },
      });
      let datas = await res.data;
      return datas;
    } else {
      return null;
    }
  },

  async updateHeader(id, data) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        // Tenta primeiro a rota padrão (sem barra final)
        const response = await axios.patch(
          `${baseUrl}pesquisa/v1/headers/${id}`, // ← sem barra
          data,
          {
            headers: {
              'Authorization': `Token ${user.token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        return response.data;
      } catch (error) {
        // Fallback para a action personalizada (também sem barra)
        console.warn('Erro na rota padrão, tentando update-codification:', error);
        try {
          const response = await axios.patch(
            `${baseUrl}pesquisa/v1/headers/${id}/update-codification`, // ← sem barra
            data,
            {
              headers: {
                'Authorization': `Token ${user.token}`,
                'Content-Type': 'application/json'
              }
            }
          );
          return response.data;
        } catch (error2) {
          console.error('Erro ao atualizar header:', error2);
          throw new Error(error2.response?.data?.error || 'Erro ao atualizar header');
        }
      }
    }
    return null;
  },

  async uploadHeader(data, id) {
    let user = authService.getLoggedUser();
    if (user) {
      let res = await axios.patch(`${baseUrl}pesquisa/v1/headers/${id}`, data, {
        headers: {
          'Authorization': `Token ${user.token}`,
        },
      });
      let datas = await res.data;
      return datas;
    } else {
      return null;
    }
  },

  async deleteHeader(id) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.delete(`${baseUrl}pesquisa/v1/headers/${id}`, {
          headers: {
            'Authorization': `Token ${user.token}`,
          },
        });
        return response.data;
      } catch (error) {
        console.error("Erro ao deletar header:", error);
        throw new Error(error.response?.data || 'Erro ao deletar header');
      }
    } else {
      return null;
    }
  },

  async deleteSection(id) {
    let user = authService.getLoggedUser();
    if (user) {
      let res = await axios.delete(`${baseUrl}pesquisa/v1/sections/${id}`, {
        headers: {
          'Authorization': `Token ${user.token}`,
        },
      });
      let datas = await res.data;
      return datas;
    } else {
      return null;
    }
  },

  async getProcessedTasks(page = 1, pageSize = 10, search = '', filters = {}) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const params = new URLSearchParams({
          page: page.toString(),
          page_size: pageSize.toString(),
        });

        if (search) {
          params.append('search', search);
        }

        if (filters.taskId) {
          params.append('task_id', filters.taskId);
        }

        if (filters.ordering) {
          params.append('ordering', filters.ordering);
        }

        const url = `${baseUrl}api/processed-tasks/?${params.toString()}`;
        console.log(`🔍 Buscando tarefas: ${url}`);

        const response = await axios.get(url, {
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });

        return {
          tasks: response.data.results || [],
          pagination: {
            count: response.data.count || 0,
            next: response.data.next,
            previous: response.data.previous,
            currentPage: page,
            totalPages: Math.ceil((response.data.count || 0) / pageSize),
            pageSize: pageSize
          }
        };
      } catch (error) {
        console.error("Erro ao buscar tarefas processadas:", error);
        return {
          tasks: [],
          pagination: {
            count: 0,
            next: null,
            previous: null,
            currentPage: 1,
            totalPages: 0,
            pageSize: pageSize
          }
        };
      }
    }
    return { tasks: [], pagination: null };
  },

  async getProcessedTaskResult(taskId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.get(`${baseUrl}api/download-result/planilha_ref/${taskId}/`, {
          responseType: 'blob',
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });

        if (response.data.size < 100) {
          const text = await new Response(response.data).text();
          if (text.includes('error') || text.includes('Error') || text.includes('Not Found')) {
            throw new Error(`Arquivo inválido: ${text.substring(0, 100)}`);
          }
        }

        return response.data;
      } catch (error) {
        if (error.response?.data) {
          try {
            const errorText = await error.response.data.text();
            console.error(`   Conteúdo do erro: ${errorText}`);
          } catch (e) {
            console.error("   Não foi possível ler conteúdo do erro");
          }
        }

        throw error;
      }
    }
    return null;
  },

  async getAllProcessedTasks(page = 1, pageSize = 10, search = '', filters = {}) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const params = new URLSearchParams({
          page: page.toString(),
          page_size: pageSize.toString(),
        });

        Object.entries(filters).forEach(([key, value]) => {
          if (value && value !== 'all') {
            params.append(key, value);
          }
        });

        if (search) {
          params.append('search', search);
        }

        const url = `${baseUrl}api/processed-tasks/?${params.toString()}`;

        const response = await axios.get(url, {
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });

        return {
          tasks: response.data.results || [],
          pagination: {
            count: response.data.count || 0,
            next: response.data.next,
            previous: response.data.previous,
            currentPage: page,
            totalPages: Math.ceil((response.data.count || 0) / pageSize),
            pageSize: pageSize
          }
        };
      } catch (error) {
        console.error("Erro ao buscar todos os processos:", error);
        throw error;
      }
    }
    return { tasks: [], pagination: null };
  },

  async getProcessDetails(taskId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.get(`${baseUrl}api/processing-status/${taskId}/`, {
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });
        return response.data;
      } catch (error) {
        console.error("Erro ao buscar detalhes do processo:", error);
        throw error;
      }
    }
    return null;
  },

  async updateTaskName(taskId, newTaskName) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.patch(
          `${baseUrl}api/task/${taskId}/update/`,
          { task_name: newTaskName },
          {
            headers: {
              'Authorization': `Token ${user.token}`,
              'Content-Type': 'application/json'
            }
          }
        );
        return response.data;
      } catch (error) {
        console.error("Erro ao atualizar nome da tarefa:", error);
        throw new Error(error.response?.data?.error || 'Erro ao atualizar tarefa');
      }
    }
    return null;
  },

  async deleteTask(taskId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.delete(
          `${baseUrl}api/task/${taskId}/delete/`,
          {
            headers: {
              'Authorization': `Token ${user.token}`
            }
          }
        );
        return response.data;
      } catch (error) {
        console.error("Erro ao excluir tarefa:", error);
        throw new Error(error.response?.data?.error || 'Erro ao excluir tarefa');
      }
    }
    return null;
  },

  async getTaskDetails(taskId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.get(
          `${baseUrl}api/task/${taskId}/`,
          {
            headers: {
              'Authorization': `Token ${user.token}`
            }
          }
        );
        return response.data;
      } catch (error) {
        console.error("Erro ao buscar detalhes da tarefa:", error);
        throw new Error(error.response?.data?.error || 'Erro ao buscar detalhes da tarefa');
      }
    }
    return null;
  },

  async getCodificadoresStats(page = 1, pageSize = 10, search = '', filters = {}) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const params = new URLSearchParams({
          page: page.toString(),
          page_size: pageSize.toString(),
          ...filters
        });

        if (search) {
          params.append('search', search);
        }

        const url = `${baseUrl}api/codificadores/?${params.toString()}`;

        const response = await axios.get(url, {
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });

        return {
          codificadores: response.data.results || [],
          pagination: {
            count: response.data.count || 0,
            next: response.data.next,
            previous: response.data.previous,
            currentPage: page,
            totalPages: Math.ceil((response.data.count || 0) / pageSize),
            pageSize: pageSize
          }
        };
      } catch (error) {
        console.error("Erro ao buscar estatísticas de codificadores:", error);
        throw error;
      }
    }
    return { codificadores: [], pagination: null };
  },
  async startCodification(headerId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.post(
          `${baseUrl}pesquisa/v1/headers/${headerId}/start-codification`,
          {},
          { headers: { 'Authorization': `Token ${user.token}` } }
        );
        return response.data;
      } catch (error) {
        console.error('Erro ao registrar início:', error);
        throw error;
      }
    }
    return null;
  },
async uploadSheet(headerId, file) {
  let user = authService.getLoggedUser();
  if (user) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await axios.post(
        `${baseUrl}pesquisa/v1/headers/${headerId}/upload-sheet`,
        formData,
        {
          headers: {
            'Authorization': `Token ${user.token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;  // { success, errors, message }
      }
      throw { message: error.message || 'Erro desconhecido' };
    }
  }
},
  async getSection(sectionId) {
    let user = authService.getLoggedUser();
    if (user) {
      return axios.get(`${baseUrl}pesquisa/v1/sections/${sectionId}/`, {
        headers: { 'Authorization': `Token ${user.token}` }
      });
    }
  },
  async completeCodification(headerId) {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.post(
          `${baseUrl}pesquisa/v1/headers/${headerId}/complete-codification`,
          {},
          { headers: { 'Authorization': `Token ${user.token}` } }
        );
        return response.data;
      } catch (error) {
        console.error('Erro ao registrar conclusão:', error);
        throw error;
      }
    }
    return null;
  },

  async getAllUsers() {
    let user = authService.getLoggedUser();
    if (user) {
      try {
        const response = await axios.get(`${baseUrl}users/`, {
          headers: {
            'Authorization': `Token ${user.token}`
          }
        });
        return response.data.results || [];
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        return [];
      }
    }
    return [];
  },
async getAllHeaders(page = 1, pageSize = 10, search = '', filters = {}) {
  let user = authService.getLoggedUser();
  if (user) {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
      ordering: '-id_header'
    });

    if (search) {
      params.append('search', search);
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.append(key, value);
      }
    });

    const url = `${baseUrl}pesquisa/v1/headers/all-headers?${params.toString()}`;

    console.log(`🔍 Buscando todas as codificações: ${url}`);

    return axios.get(url, {
      headers: {
        Authorization: `Token ${user.token}`
      }
    });
  }
  return null;
},
  async downloadHeaderImages(headerId, roadName = '') {
    const user = authService.getLoggedUser();
    if (!user) return null;

    try {
      const response = await axios.get(
        `${baseUrl}pesquisa/v1/headers/${headerId}/download-images`,
        {
          responseType: 'blob',
          headers: { 'Authorization': `Token ${user.token}` },
          timeout: 120000
        }
      );

      const safeRoad = (roadName || 'via')
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[\\/:*?"<>|]/g, '');

      const filename = `${safeRoad}_${headerId}.zip`;

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      console.error('Erro ao baixar imagens:', error);
      throw new Error(error.response?.data?.error || 'Erro ao baixar imagens');
    }
  },
};